import { render, staticRenderFns } from "./storeOrderCart.vue?vue&type=template&id=354cc474&scoped=true"
import script from "./storeOrderCart.vue?vue&type=script&lang=js"
export * from "./storeOrderCart.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCart.vue?vue&type=style&index=0&id=354cc474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354cc474",
  null
  
)

export default component.exports